<template>
  <div :class="['filter-container flex-row', dbOptionHeight]">
    <div class="filter-op">
      <ms-validate ref="validateObserver">
        <ms-validate ref="validateObserver">
          <menu-wrapper>
            <template #menu-button="{toggleMenu}">
              <button tabindex="-1" @click="toggleMenu" :class="['btn-filter-operator', dbOptionHeight]">
                <div :class="['icon24', nativeFilterIconClass]"></div>
              </button>
            </template>
            <template #menu-content>
              <template v-for="(item, i) in filterOperators" :key="i">
                <menu-item
                  class="filter-operator-item"
                  :class="item.enumValue === operatorValue ? 'active' : ''"
                  @menu-item-click="filterOperatorItemClick(item)"
                  :icon="['icon24', item.icon]"
                  >{{ item?.enumText }}</menu-item
                >
              </template>
            </template>
          </menu-wrapper>
        </ms-validate>
      </ms-validate>
    </div>
    <div class="filter-value flex">
      <ms-combobox
        v-if="operatorValue == '=' || operatorValue == '!=' || col.formatType == 116"
        v-model="filterValue"
        :displayField="propsData.suffixDisplayField ? propsData.displayField : col.displayField ?? col.dataField"
        :valueField="propsData.suffixDisplayField ? propsData.valueField : col.dataField"
        :suffixDisplayField="propsData.suffixDisplayField"
        v-model:display="displaySuffixValue"
        ref="thEnum"
        class="ms-input-filter-value"
        :title="col.tooltip || col.title || col.definition || col.caption"
        :isShowText="false"
        :data="comboData"
        :remote-filter="propsData.queryMode === 'remote' ? true : false"
        :columnSearch="propsData.columnSearch"
        :columns="propsData.columns"
        :dropdownWidth="propsData.dropdownWidth"
        :formatType="col.formatType"
        :queryMode="propsData.queryMode"
        @filterGrid="filterSearchGrid"
        :filterSeachGrid="col.filterSeachGrid"
        @selected="
          ({newData}) => {
            let filterArr = [];
            if (propsData.columns) {
              propsData.columns?.forEach(function (item, undex) {
                filterArr.push({
                  field: item.dataField,
                  operator: operatorValue,
                  value: newData
                    ? propsData.suffixDisplayField
                      ? displaySuffixValue
                      : newData[item.dataField]
                    : newData,
                });
              });
            } else {
              filterArr = {
                operator: operatorValue,
                value: newData ? (propsData.suffixDisplayField ? displaySuffixValue : newData[col.dataField]) : newData,
              };
            }

            filterHeaderHandle(filterArr);
          }
        "
        @comboboxLoadData="
          payload =>
            onComboboxLoadData(payload, null, {
              dataField: col.dataField,
              sender: thEnum,
            })
        "
        @keydown.stop=""
        :hasBorder="false"
        :isGridEditor="isGridEditor"
      ></ms-combobox>

      <ms-input
        v-else
        ref="thEnum"
        v-model="filterValue"
        class="ms-input-filter-value"
        @keydown.stop=""
        :hasBorder="false"
      />
    </div>
  </div>
</template>
<script>
import {defineComponent, getCurrentInstance, ref, computed} from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
export default defineComponent({
  extends: msThOptionBase,
  components: {MenuItem, MenuWrapper},
  name: 'MsThOptionCombobox',
  props: {
    filterIconClass: {
      type: String,
      default: 'ic-filter-equal',
    },
    propsData: {
      default: {},
      type: Object,
    },
    isGridEditor: {
      default: false,
      type: Boolean,
    },
    dbOptionHeight: {
      type: String,
    },
  },
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();

    /**
     * lấy dữ liệu combo cho filter header
     * ntchuyen 07.11.2025
     */
    const comboData = computed(() => {
      if (props.propsData.queryMode === 'remote') {
        return props.propsData.data[props.col.dataField];
      }

      if (typeof props.propsData.customLoadData == 'function') {
        return props.propsData.customLoadData(props);
      }

      return props.propsData.data;
    });

    /**
     * Giá trị hiển thị của filter
     * NXCHIEN 30.05.2023
     */
    const displaySuffixValue = ref();

    //Khai báo data variable
    const {
      nativeFilterIconClass,
      operatorValue,
      filterValue,
      filterOperators,
      filterHeaderHandle,
      filterOperatorItemClick,
      removeFilter,
      thEnum,
      updateFilterValue,
    } = setup(props, {
      emit,
    });

    /**
     * filter table
     * nnninh 07/12/2023
     */
    const filterSearchGrid = value => {
      filterHeaderHandle({operator: operatorValue, value: value});
    };

    /**
     * Băn sự kiện loadData ra bên ngoài để gọi API
     * dqvinh 23.05.2023
     * Modified by ntchuyen 06.11.2025 lấy dữ liệu combo cho filter header
     */
    const onComboboxLoadData = async (payload, row, dataField) => {
      if (props.propsData?.comboboxLoadData && typeof props.propsData.comboboxLoadData === 'function') {
        await props.propsData.comboboxLoadData(payload, row, dataField);
      } else {
        emit('load-filter-header', payload, row, dataField);
      }
    };

    //Hooks
    return {
      nativeFilterIconClass,
      filterValue,
      operatorValue,
      filterOperators,
      filterOperatorItemClick,
      filterHeaderHandle,
      removeFilter,
      thEnum,
      onComboboxLoadData,
      displaySuffixValue,
      filterSearchGrid,
      updateFilterValue,
      comboData
    };
  },
});
</script>
